import { observer } from 'mobx-react';
// https://surveyjs.io/form-library/documentation/manage-default-themes-and-styles
import 'survey-core/defaultV2.min.css';
import 'survey-core/survey.i18n';
import {
  cannabisConsumptionQuestionnaireReqDto,
  CannabisConsumptionQuestionnaireResult,
  ErrorCode,
} from '@web/common';
import classes from '../../../../sharedStyles/Containers.module.css';
import { Button, Container, Flex } from '@mantine/core';
import { Questionnaire } from '../../../../component/questionnaire';
import { Header } from '../../../public/navigation';
import { DevContent } from '../../../../util/DevContent';
import { useState } from 'react';
import { devRandomize } from './dev-randomize';
import { getCannabisConsumptionQuestionnaireSurveyJSON } from './cannabis-consumption-survey-specification';
import { showErrorNotification } from '../../../../component/notification';
import { useTranslation } from 'react-i18next';

export const CannabisConsumptionQuestionnaireContent = observer(
  ({
    surveyComplete,
  }: {
    surveyComplete: (
      surveyResult: CannabisConsumptionQuestionnaireResult,
    ) => void;
  }) => {
    const { t } = useTranslation('consumption-questionnaire');
    const [initialData, setInitialData] = useState({});

    return (
      <div>
        <Header canLogout />
        <Container fluid className={classes.container} maw="1200px">
          <Questionnaire
            title={t('Title')}
            questionnaire={{
              json: getCannabisConsumptionQuestionnaireSurveyJSON(t),
              schema: cannabisConsumptionQuestionnaireReqDto,
              initial: initialData,
            }}
            onComplete={surveyComplete}
            onError={() =>
              showErrorNotification(ErrorCode.QuestionnaireParsingError)
            }
          />
        </Container>
        <DevContent>
          <Flex direction="row" gap="10px">
            <Button onClick={() => setInitialData(devRandomize(t))}>
              Randomize
            </Button>
          </Flex>
        </DevContent>
      </div>
    );
  },
);
